import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private cookie: CookieService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.cookie.get('XSRF-TOKEN');
    if (token && token.length > 0) {
      req = this.setXSRFToken(req, token);
    }
    return next.handle(req);
  }

  setXSRFToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    req = req.clone({
      setHeaders: {
        'X-XSRF-TOKEN': token,
      },
      withCredentials: true,
    });

    return req;
  }
}
